// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-lesson-activities {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: #a9f192;
  max-height: 350px;
  overflow-y: auto;
}

.manage-lesson-activities h2 {
  text-align: center;
  margin-bottom: 20px;
}

.activity-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 20px;
  margin-bottom: 20px;
}

.activity-card h3 {
  font-weight: bold;
  margin-bottom: 10px;
}

.activity-type {
  font-style: italic;
}

.buttonsinz {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.edit-button {
  background-color: #5feafc;
}

.delete-button {
  background-color: red;
}


.assign-form {
  background-color: #27b151;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.assign-form h3 {
  margin-top: 0;
  font-size: large;
}

.form-group {
  margin-bottom: 10px;
}

.custom-label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.custom-input,
.custom-textarea,
.custom-select {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.custom-aqua-button {
  margin-left: 5px;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 3px;
  background-color: #00bcd4;
  color: #fff;
  cursor: pointer;
}

.add-button {
  display: block;
  margin: 0 auto;
  padding: 20px;
  font-size: 16px;
  border-radius: 5px;
  background-color: #00bcd4;
  color: #fff;
  cursor: pointer;
}

.add-button:hover,
.custom-aqua-button:hover,
.edit-button:hover,
.delete-button:hover,
.assign-button:hover {
  background-color: #f3f8f9;
}

.activity-card {
  background-color: #f0ed65;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.activity-name {
  font-weight: bold;
  margin-bottom: 10px;
}

.activity-description {
  margin-bottom: 10px;
}

.buttons-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.edit-button,
.delete-button,
.assign-button {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
  margin-right: 10px;
}

.assign-button {
  background-color: rgb(78, 173, 252);
  color: black;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
}

.modal-content {
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.copy-activity-form {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
  max-width: 400px;
  margin: 0 auto;
}

.copy-activity-form FormGroup {
  margin-bottom: 15px;
}

.copy-activity-form Label {
  display: block;
  margin-bottom: 5px;
}

.copy-activity-form Input[type="select"] {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.copy-activity-form button {
  background-color: #4caf50;
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.copy-activity-form button:hover {
  background-color: #45a049;
}

/* Modal.css */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}


.modalStyle {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  padding: 20px;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 400px;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/ManageLessonActivities.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".manage-lesson-activities {\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  background-color: #a9f192;\n  max-height: 350px;\n  overflow-y: auto;\n}\n\n.manage-lesson-activities h2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.activity-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  grid-gap: 20px;\n  margin-bottom: 20px;\n}\n\n.activity-card h3 {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.activity-type {\n  font-style: italic;\n}\n\n.buttonsinz {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.edit-button {\n  background-color: #5feafc;\n}\n\n.delete-button {\n  background-color: red;\n}\n\n\n.assign-form {\n  background-color: #27b151;\n  padding: 20px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n.assign-form h3 {\n  margin-top: 0;\n  font-size: large;\n}\n\n.form-group {\n  margin-bottom: 10px;\n}\n\n.custom-label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.custom-input,\n.custom-textarea,\n.custom-select {\n  width: 100%;\n  padding: 10px;\n  font-size: 14px;\n  border-radius: 3px;\n  border: 1px solid #ccc;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.custom-aqua-button {\n  margin-left: 5px;\n  padding: 10px 20px;\n  font-size: 14px;\n  border-radius: 3px;\n  background-color: #00bcd4;\n  color: #fff;\n  cursor: pointer;\n}\n\n.add-button {\n  display: block;\n  margin: 0 auto;\n  padding: 20px;\n  font-size: 16px;\n  border-radius: 5px;\n  background-color: #00bcd4;\n  color: #fff;\n  cursor: pointer;\n}\n\n.add-button:hover,\n.custom-aqua-button:hover,\n.edit-button:hover,\n.delete-button:hover,\n.assign-button:hover {\n  background-color: #f3f8f9;\n}\n\n.activity-card {\n  background-color: #f0ed65;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.activity-name {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.activity-description {\n  margin-bottom: 10px;\n}\n\n.buttons-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.edit-button,\n.delete-button,\n.assign-button {\n  padding: 10px 20px;\n  font-size: 14px;\n  border-radius: 3px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n\n.assign-button {\n  background-color: rgb(78, 173, 252);\n  color: black;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-y: scroll;\n}\n\n.modal-content {\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.copy-activity-form {\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #fff;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.copy-activity-form FormGroup {\n  margin-bottom: 15px;\n}\n\n.copy-activity-form Label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.copy-activity-form Input[type=\"select\"] {\n  width: 100%;\n  padding: 8px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.copy-activity-form button {\n  background-color: #4caf50;\n  color: #fff;\n  padding: 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.copy-activity-form button:hover {\n  background-color: #45a049;\n}\n\n/* Modal.css */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n.modalStyle {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #ffffff;\n  padding: 20px;\n  border: 1px solid #ccc;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 400px;\n  max-height: 500px;\n  overflow-y: auto;\n  border-radius: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
